document.addEventListener("DOMContentLoaded",()=>{
  const m=document.querySelector(".menu"),n=document.querySelector(".mobile-nav");
  if(m)m.onclick=()=>{let o=m.getAttribute("aria-expanded")==="true";m.setAttribute("aria-expanded",!o);n.classList.toggle("open",!o)};
  document.querySelectorAll(".mobile-nav a").forEach(a=>a.onclick=()=>n.classList.remove("open"));
  const o=new IntersectionObserver(es=>es.forEach(e=>e.isIntersecting&&e.target.classList.add("visible")),{threshold:.12});
  document.querySelectorAll(".reveal").forEach(x=>o.observe(x));

  // Sıralı kart animasyonu
  var cards=document.querySelectorAll('.cards .card');
  var revealObserver=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        var card=entry.target;
        var index=Array.from(cards).indexOf(card);
        card.style.transitionDelay=(index*0.15)+'s';
        revealObserver.unobserve(card);
      }
    });
  },{threshold:0.1});
  cards.forEach(function(card){revealObserver.observe(card);});

  // ELITE kart glow
  var featured=document.querySelector('.card.featured');
  if(featured){
    featured.style.transition='box-shadow 1.5s ease';
    featured.style.boxShadow='0 0 40px rgba(255,90,0,0.15)';
    setInterval(function(){
      featured.style.boxShadow=featured.style.boxShadow.includes('0.15')
        ?'0 0 60px rgba(255,90,0,0.28)'
        :'0 0 40px rgba(255,90,0,0.15)';
    },1500);
  }
});
